var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M239.976 50.022c16.565 0 29.993 13.428 29.993 29.992v119.972c0 16.565-13.428 29.992-29.993 29.992H40.024c-16.565 0-29.993-13.427-29.993-29.992V80.014c0-16.564 13.428-29.992 29.993-29.992zm-20.428 36.595-74.117 47.958a10 10 0 0 1-10.863 0L60.452 86.617c-4.636-3-10.826-1.673-13.825 2.963-3 4.635-1.674 10.824 2.962 13.825l74.117 47.957a29.99 29.99 0 0 0 32.588 0l74.116-47.957c4.636-3 5.963-9.19 2.964-13.825-3-4.636-9.19-5.962-13.826-2.963"
})));
export default SvgEmail;